import { MyTooltip } from "../common/MyTooltip";

export const ExistsInCollectionTooltip = ({
  resourceSource = "FILE",
}: {
  resourceSource?: "FILE" | "LINK";
}) => {
  let message = "";

  message =
    "This link exists already, if you proceed the existing record will be updated with the latest content on the page.";

  return (
    <MyTooltip
      title={
        <>
          <span
            style={{
              color: "var(--text-color-primary",
            }}>
            {message}
          </span>
        </>
      }>
      <img
        src={"/icons/red-exclaim.svg"}
        onClick={() => {}}
        // style={{
        //   outline: fu.selected
        //     ? "2px solid var(--unseen-badge-color)"
        //     : "1px solid var(--container-border-color)",
        // }}
        className="file-exclaim"
        alt=""
      />
    </MyTooltip>
  );
};
